import { translateKey as t } from "../../../../../../locales/translation";
import { AppStore } from "~/stores/AppStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faUpload } from "@fortawesome/free-solid-svg-icons";
import { observer } from "mobx-react";
import { ClientsController } from "../../../ClientsController";
import { Button, Divider, Popconfirm, Tag, Upload, Typography, Flex, Alert, Dropdown, MenuProps } from "antd";
import { DeleteOutlined, DownOutlined, EyeOutlined, LoadingOutlined } from "@ant-design/icons";

const { Title } = Typography;
const { Dragger } = Upload;

const ImportModalContent = observer(({ store, controller }: { store?: AppStore; controller?: ClientsController }) => {
  console.log("RENDER ImportModalContent");
  const { dataImporterModal, formatText } = controller;

  const renderFileDetails = () => {
    let content;

    if (dataImporterModal.uploadLoading) {
      content = (
        <Flex gap="4px 0" wrap justify={"center"}>
          <LoadingOutlined />
        </Flex>
      );
    } else if (controller.dataImporterModal.importedData.length > 0) {
      content = (
        <Flex gap="4px 0" wrap justify={"center"}>
          {controller.dataImporterModal.importedData.map((dataPassed) => {
            return (
              <Tag bordered={false} color="processing">
                {formatText(dataPassed.sheetName)}: {dataPassed.result.length}
              </Tag>
            );
          })}
        </Flex>
      );
    } else {
      content = (
        <Flex gap="4px 0" wrap justify={"center"}>
          <Tag bordered={false} color="error">
            No Data Found
          </Tag>
        </Flex>
      );
    }

    return content;
  };

  const items: MenuProps["items"] = [
    {
      label: "Master Data Template",
      key: "0",
      onClick: () => controller.handleTemplateDownload("masterData"),
    },
    {
      label: "Mobile Data Template",
      key: "1",
      onClick: () => controller.handleTemplateDownload("mobileData"),
    },
  ];

  return (
    <div style={{ margin: "10px 0px" }}>
      <div className="flex justify-end items-center mb-4">
        <Dropdown menu={{ items }} trigger={["click"]}>
          <Button size="small" icon={<FontAwesomeIcon icon={faDownload} />}>
            Download Template
            <DownOutlined />
          </Button>
        </Dropdown>
      </div>

      <Divider style={{ margin: "10px 0px" }} />

      <div>
        {dataImporterModal.file ? (
          <div className="flex flex-col justify-center items-center">
            <span className="flex">
              <Title level={5} style={{ marginTop: 5 }}>
                {dataImporterModal.file.name}
              </Title>

              <div style={{ marginTop: 5 }}>
                <Popconfirm
                  title={t("lblAreYouSureDeleteFile", "Are you sure you want to delete this file?")}
                  onConfirm={() => {
                    //Clear file and imported data
                    controller.setDataImporterModal("file", null);
                    controller.setDataImporterModal("importedData", []);
                    controller.setDataImporterModal("preDataErrors", []);
                    controller.setDataImporterModal("postDataErrors", []);
                  }}
                >
                  <Button size="small" danger style={{ marginLeft: 5 }} icon={<DeleteOutlined />}>
                    {/* {t("lblDeleteFile", "Delete File")} */}
                  </Button>
                </Popconfirm>

                <Button
                  size="small"
                  style={{ marginLeft: 5 }}
                  icon={<EyeOutlined />}
                  onClick={() => {
                    if (controller?.jsonViewer?.loadModal) {
                      controller.jsonViewer.loadModal(dataImporterModal.file.name, controller.dataImporterModal.importedData, dataImporterModal.file.name);
                    }
                  }}
                ></Button>
              </div>
            </span>

            <Divider style={{ margin: 10 }} />
            {renderFileDetails()}
          </div>
        ) : (
          <Dragger
            beforeUpload={(file) => {
              if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                store.displayNotification(t("lblIncorrectFileType", "Incorrect File Type"), "error", true);
                return false;
              } else {
                controller.setDataImporterModal("file", file);
                controller.handleUploadFile();
                return true;
              }
            }}
            fileList={null}
            accept=".xlsx"
          >
            <p className="ant-upload-drag-icon">
              <FontAwesomeIcon icon={faUpload} />
            </p>
            <p className="ant-upload-text">Upload Data Importer File as Xlsx</p>
          </Dragger>
        )}
      </div>

      {(dataImporterModal?.postDataErrors?.length > 0 || dataImporterModal?.preDataErrors?.length > 0) && (
        <Alert
          style={{ margin: "10px 0px" }}
          showIcon
          description="One or more imported datasets fail to meet their defined specifications."
          type="error"
          action={
            <Button size="small" danger onClick={() => controller.setImporterErrorsModal("visible", true)}>
              View
            </Button>
          }
        />
      )}
    </div>
  );
});

export default ImportModalContent;
